module.exports = __webpack_public_path__ + "img/staff-kirsty-north.0b3d3147.jpg";